export const validateExtension = (file, accept) => {
  const lastIndex = file.name.lastIndexOf(".");
  if (lastIndex > 0) {
    const ext = file.name.substring(lastIndex);
    return accept.length === 0 || accept.includes(ext.toLowerCase());
  }
  return false;
};
